<template>
  <div class="home">
    <Header />

    <ProductPreview
      id="chauffage"
      title="Chauffage"
      text="Nous remplaçons et dépannons votre chaudière à gaz.<br />
      Nous travaillons en partenariat avec les plus grandes marques et
      vous proposerons d'entretenir votre chaudière annuellement.
      Vous opterez ainsi pour la tranquillité !
      "
      image="/images/main/chauffage.jpg"
      link="chauffage"
      color="is-warning"
      icon="fire"
    />

    <ProductPreview
      id="decoration"
      title="Peinture et décoration"
      text="
      Nos équipes de peintres et décorateurs redonneront une nouvelle
      jeunesse à votre intérieur. <br />Changement de couleur, pose de
      revêtement mural ou envie d'un nouveau sol, nous saurons vous
      guider pour faire de votre chez vous un lieu agréable à vivre.
      "
      image="/images/main/decoration.jpg"
      link="decoration"
      color="is-info"
      icon="format-paint"
    />

    <ProductPreview
      id="sanitaire"
      title="Salle de bain et sanitaire"
      text="
      Envie d'une nouvelle salle de bain ?<br />
      Nous vous accompagnons dans la réalisation de votre projet.
      Toujours à votre écoute, nous réalisons la pose de vos 
      équipements sanitaires ainsi que le remplacement de votre chauffe-eau.
      "
      image="/images/main/sanitaire-1.jpg"
      link="sanitaire"
      icon="toilet"
    />

    <div class="contact">
      <div>
        <router-link to="contact" class="button is-info is-medium">Contactez-nous</router-link>
        <br />
        <br />
        <span class="heading">Les devis sont gratuits</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.contact {
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 2em 3em;
}

.heading {
  font-size: 12pt;
}
</style>

<script>
// Components
import ProductPreview from "@/components/ProductPreview";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    ProductPreview,
    Header
  }
};
</script>
